<template>
    <div class="app_field">
        <!-- banner -->
        <div class="banner">
            <div class="banner_text">
                <p>行业应用</p>
                <p>Industry Applications</p>
            </div>
             <img v-if="banner" :src="banner" alt="" />
			<img v-else src="./../../assets/images/home/news_banner.png" alt="" />
        </div>
        <div class="main">
            <div class="sidebar">
                <ul class="list">
                    <li v-for="item in appData" :key="item.title" :class="{active:selectIndex==item.id}" @click="lookDetail(item)">{{item.title}}</li>
                    <!-- <li class="active">智慧城市领域</li>
                    <li>工业制造领域</li>
                    <li>农业生产领域</li>
                    <li>烟草应用领域</li>
                    <li>医疗器械领域</li>
                    <li>快消品流通领域</li>
                    <li>交通运输领域</li>
                    <li>文化传播领域</li> -->
                </ul>
            </div>
            <div class="article">
                <h3 class="title">{{detailData.title}}</h3>
                <div class="ql-editor content" v-html="detailData.content">
                    <!-- <p>智慧城市代码标识体系为各个城市及城市管理对象分配统一身份标识，即“数字身份证”，编码结构可实现对标识对象身份信息和属性信息的管理，同时可实现对其它编码结构的兼容。致力于解决城市之间、城市内部各部门、各行业之间的代码统一和数据互通问题，破解数据“共享”与“安全”悖论，是智慧城市建设的基础设施。城市代码标识体系是推动标识代码底层技术服务和新型智慧城市建设相结合的创新实践，为“新基建”提供标识技术支撑,助推城市经济转型升级。</p>
                    <img src="./../../assets/images/home/home_banner.png" alt="">
                    <img src="./../../assets/images/home/home_banner.png" alt="">
                    <p>智慧城市代码标识体系为各个城市及城市管理对象分配统一身份标识，即“数字身份证”，编码结构可实现对标识对象身份信息和属性信息的管理，同时可实现对其它编码结构的兼容。致力于解决城市之间、城市内部各部门、各行业之间的代码统一和数据互通问题，破解数据“共享”与“安全”悖论，是智慧城市建设的基础设施。城市代码标识体系是推动标识代码底层技术服务和新型智慧城市建设相结合的创新实践，为“新基建”提供标识技术支撑,助推城市经济转型升级。</p>
                    <p>智慧城市代码标识体系为各个城市及城市管理对象分配统一身份标识，即“数字身份证”，编码结构可实现对标识对象身份信息和属性信息的管理，同时可实现对其它编码结构的兼容。致力于解决城市之间、城市内部各部门、各行业之间的代码统一和数据互通问题，破解数据“共享”与“安全”悖论，是智慧城市建设的基础设施。城市代码标识体系是推动标识代码底层技术服务和新型智慧城市建设相结合的创新实践，为“新基建”提供标识技术支撑,助推城市经济转型升级。</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {acticleList,contentdetail} from '@/api/home'
export default {
    name:"AppField",
    data(){
        return {
            appData:[],//列表数据
            selectIndex:'',//选中的索引
            detailData:{},//文章内容
            banner:'',
        }
    },
    mounted(){
        this.acticleList();
        this.banner = this.$route.query.banner || '';
        console.log(this.banner,"app")
    },
    methods:{
        acticleList(){//通过栏目id获取内容列表
         console.log(this.$route.query.id ,"this.$route.query.id ")
            acticleList({
                columnId:this.$route.query.id }).then(res=>{//栏目id2
                // console.log('应用领域');
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.appData=res.data||[]
                if (this.appData.length!=0) {
                    if (this.$route.query.columnId) {// 列表id
                        this.selectIndex=this.$route.query.columnId
                        for (let i = 0; i < this.appData.length; i++) {
                            if (this.appData[i].id==this.selectIndex) {
                                this.lookDetail(this.appData[i])
                                break
                            }
                        }
                    }else{
                        this.selectIndex=this.appData[0].id
                        this.lookDetail(this.appData[0])
                    }
                }
            })
        },
        lookDetail(v){//查看文章
            this.selectIndex=v.id
            // contentdetail({
            //     id//栏目id
            // }).then(res=>{
            //     // console.log('通过内容id获取内容详情');
            //     // console.log(JSON.parse(JSON.stringify(res.data)))
                this.detailData=v
				this.detailData.content = this.detailData.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'");
            // })
        }
    }
}
</script>

<style lang='scss' scoped>
    .app_field{
        width: 100%;
	height: 100%;
	overflow: hidden auto;
        background-color: #FAFAFA;
        padding-bottom: 84px;
        box-sizing: border-box;
        .banner{
            width: 100%;
            position: relative;
            font-size: 0;
            .banner_text{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 1200px;
                p:nth-child(1){
                    font-size: 30px;
                    color: #333;
                }
                p:nth-child(2){
                    font-size: 24px;
                    color: #C9ECE1;
                    margin-top: 15px;
                    color: #333;
                    line-height: 41px;
                }
            }
            img{
                width: 100%;
                max-height: 400px;
            }
        }
        .main{
            width: 1200px;
            margin: 30px auto 0;
            // border: 1px solid #f00;
            display: flex;
            .sidebar{
                background-color: #fff;
                // border: 1px solid #0f0;
                width: 285px;
                flex: none;
                padding: 30px 30px 5px;
                box-sizing: border-box;
                .list{
                    >li{
                        background-color: #F3F3F3;
                        height: 65px;
                        width: 100%;
                        margin-bottom: 25px;
                        font-size: 16px;
                        color: #666;
                        text-align: center;
                        line-height: 65px;
                        cursor: pointer;
                       text-overflow: ellipsis;
                        display: -webkit-box !important;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                    .active{
                        background-color: #0C4099;
                        color: #fff;
                    }
                }
            }
            .article{
                background-color: #fff;
                // border: 1px solid #f0f;
                flex: 1;
                margin-left: 30px;
                padding: 55px 80px;
                box-sizing: border-box;
                overflow: hidden;
                >h3.title{
                    color: #000;
                    font-size: 20px;
                    text-align: center;
                    font-weight: 600;
                }
                .content{
                    margin-top: 30px;
                    p{
                        line-height: 1.5;
                    }
                    img{
                        max-width: 100%;
                    }
                }
            }
        }
    }
</style>